import Axios, { AxiosRequestConfig } from 'axios';

// TODO- remove this interceptor once we are completely off of AngularJS- ARM END GAME
export function removeHashKeyFromPayload(config: AxiosRequestConfig) {
  const NON_JSON_TYPES = [Blob, FormData, URLSearchParams];
  if (config?.data && !NON_JSON_TYPES.some(BodyType => config.data instanceof BodyType)) {
    config.data = JSON.parse(JSON.stringify(config.data, (k, v) => k === '$$hashKey' ? undefined : v));
  }
  return config;
}

Axios.interceptors.request.use(removeHashKeyFromPayload);